import { Steps } from "antd";
import { useState } from "react";
import {
  VerifyStep,
  CarinfoStep,
  ServiceStep,
  TimeStep,
  PaymentStep,
} from "../../components";
const STEPS = [
  {
    title: "Хэрэглэгч баталгаажуулах",
  },
  {
    title: "Машины мэдээлэл",
  },
  {
    title: "Үйлчилгээ сонгох",
  },
  {
    title: "Өдөр/цаг сонгох",
  },
  {
    title: "Баталгаажуулах",
  },
];

const Index = (props) => {
  const [step, setStep] = useState(0);

  const renderSteps = () => {
    switch (step) {
      case 0:
        return <VerifyStep {...props} setStep={setStep} step={step} />;
      case 1:
        return <CarinfoStep {...props} setStep={setStep} step={step} />;
      case 2:
        return <ServiceStep {...props} setStep={setStep} step={step} />;
      case 3:
        return <TimeStep {...props} setStep={setStep} step={step} />;
      case 4:
        return <PaymentStep {...props} setStep={setStep} step={step} />;
      default:
        return null;
    }
  };

  return (
    <div className="container pt-4 lg:pt-10 px-4 lg:p-0 overflow-y-auto pb-4 lg:pb-10 w-full">
      <Steps
        current={step}
        //percent={100}
        className="hidden lg:flex"
        items={STEPS}
      />
      <div className="flex lg:hidden items-center gap-2">
        <div className="bg-primary rounded-full w-8 h-8 flex items-center justify-center">
          <span className="text-white">{step + 1}</span>
        </div>
        <span>{STEPS[step]?.title || ""}</span>
      </div>
      <div className="pt-4 lg:pt-8 flex">{renderSteps()}</div>
    </div>
  );
};

export default Index;
